import React from 'react';
import { Text } from '@mantine/core';

const LEGEND_ITEMS = [
    {
        label: 'This Year',
        shortLabel: 'TY',
    },
    {
        label: 'Last Year',
        shortLabel: 'LY',
    },
] as const;

export function ProductSalesChartLegend({
    thisYearLabel = 'This Year',
    lastYearLabel = 'Last Year',
}: {
    thisYearLabel?: string;
    lastYearLabel?: string;
}) {
    const items = [
        { ...LEGEND_ITEMS[0], label: thisYearLabel },
        { ...LEGEND_ITEMS[1], label: lastYearLabel },
    ];

    return (
        <div className="flex flex-wrap items-center gap-4">
            {items.map(item => (
                <div key={item.shortLabel} className="flex items-center gap-2">
                    <span
                        className={
                            item.shortLabel === 'TY'
                                ? 'inline-block h-3 w-3 shrink-0 rounded-sm bg-[#77E1DB]'
                                : 'inline-block h-3 w-3 shrink-0 rounded-sm bg-primary'
                        }
                        aria-hidden
                    />
                    <Text size="sm" className="text-[#4D5E80]">
                        {item.label}{' '}
                        <Text span size="xs" className="text-[#7D8FB3]">
                            ({item.shortLabel})
                        </Text>
                    </Text>
                </div>
            ))}
        </div>
    );
}

export default ProductSalesChartLegend;
